import React from 'react';
import {PulseIndicator} from "react-native-indicators";
import {ActivityIndicator, Platform, StyleSheet, Text, View} from "react-native";
import {useDispatch, useSelector} from 'react-redux';
import {getLoading, setLoading} from "../reducers/configSlice";
import HiddenLongPress from "./HiddenLongPress";
import {FONT_FAMILY_LIGHT} from "../constants/styleConstants";
import {EventBus} from "../services/EventBus";

import {actuatedNormalize} from "../services/helpers/stylingHelpers";

const Loader = () => {
    const loading = useSelector(getLoading)
    const dispatch = useDispatch()

    const _disconnect = async () => {
        EventBus.emit('destroyInstance');
        dispatch(setLoading(false))
    }

    let loader = Platform.OS === "ios" ?
        <View tint="dark" intensity={80} style={styles.loaderContainer}>
            <ActivityIndicator size="large" color="#00A0BF" />
            <Text style={styles.loaderText}>
                {translate("Please wait")}...
            </Text>
            <HiddenLongPress onEvent={_disconnect} position={'topRight'}/>
        </View> :
        <View style={styles.loaderContainer}>
            <PulseIndicator color='#00A0BF' size={72} frequency={1000} />
            <Text style={styles.loaderText}>
                {translate("Please wait")}...
            </Text>
            <HiddenLongPress onEvent={_disconnect} position={'topRight'}/>
        </View>;

    return (loading && loader)
};

const styles = StyleSheet.create({
    loaderContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
    },
    loaderText: {
        alignSelf: 'center',
        position: 'absolute',
        top: '55%',
        color: 'white',
        fontFamily: FONT_FAMILY_LIGHT,
        fontSize: actuatedNormalize(24)
    }
});

export default Loader;
